import Vue from 'vue'
import Vuex from 'vuex'

// Utilities
import * as firebase from "../firebase"
import { auth } from '../firebase'
import router from "../router/index"

// Style and components
import { SnackbarProgrammatic as screenMessage } from 'buefy'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userProfile: {},
    news: [],
    loading: false,
    yourProgress: 20,
    name: "",
    message: "",
    projectName: "",
    projectDescription: ""
  },
  getters: {
  },
  mutations: {
    // Fundamental
    setUserProfile(state, payload) {
      state.userProfile = payload;
    },
    // Load state
    setLoadStateOn(state) {
      state.loading = true;
    },
    setLoadStateOff(state) {
      state.loading = false;
    },
    setMessage(state, payload) {
      state.name = payload.name;
      state.message = payload.message;
    },
    setProject(state, payload) {
      state.projectName = payload.projectName;
      state.projectDescription = payload.description;
    },
  },
  actions: {
    // Fundamentals
    async fetchUserProfile({ commit }, user) {
      await firebase.usersCollection.doc(user.uid).get().catch(function(error) {
        screenMessage.open({type: "is-danger", message: error.message});
        commit("setLoadStateOff");
      }).then((payload) => {
        const userProfile = payload;
        commit("setUserProfile", userProfile.data());
        commit("setLoadStateOff");
      });
    },
    // Login management
    async login({ dispatch, commit }, form) {
        commit("setLoadStateOn");
        await firebase.auth.signInWithEmailAndPassword(form.email, form.password).catch(function(error) {
          screenMessage.open({type: "is-danger", message: error.message});
          commit("setLoadStateOff");
        }).then((payload) => {
          var fetchedUser
          if (payload) {
            fetchedUser = payload.user;
          } else {
            return
          }
          commit("setLoadStateOff");
          router.push("/overview");
          dispatch("fetchUserProfile", fetchedUser);
        });
    },
    async register({ dispatch, commit }, form) {
      commit("setLoadStateOn");
      const { user } = await firebase.auth.createUserWithEmailAndPassword(form.email, form.password).catch(function(error) {
        screenMessage.open({type: "is-danger", message: error.message});
        commit("setLoadStateOff");
      });
      await firebase.usersCollection.doc(user.uid).set({
        firstName: form.firstName,
        lastName: form.lastName,
        phone: form.phone,
        email: form.email,
        company: form.company,
        password: form.password,
        termsAccepted: form.termsAccepted,
        disclaimerAccepted: form.disclaimerAccepted,
        createdDate: form.createdDate
      }).catch(function(error) {
        screenMessage.open({type: "is-danger", message: error.message});
      });
      dispatch("fetchUserProfile", user);
      router.push("/overview");
      await firebase.emailCollection.doc().set({
        to: form.email,
        template: {
          name: "welcomeMail",
          data: {
            firstName: form.firstName
          }
        }
      }).catch(function(error) {
        screenMessage.open({type: "is-danger", message: error.message});
      });
    },
    async logout({ commit }) {
      await firebase.auth.signOut()
      commit("setUserProfile", {});
      router.push("/login/logged-out");
    },
    async updateProfileInformation({ commit }, payload) {
      commit("setLoadStateOn");
      var user = auth.currentUser
      await firebase.usersCollection.doc(user.uid).set({
        firstName: payload.firstName,
        lastName: payload.lastName,
        phone: payload.phone,
        email: payload.email,
        company: payload.company,
        password: payload.password,
        termsAccepted: payload.termsAccepted,
        disclaimerAccepted: payload.disclaimerAccepted,
        createdDate: payload.createdDate
      }).catch(function(error) {
        screenMessage.open({type: "is-danger", message: error.message});
      });
      screenMessage.open({type: "is-success", message: "Details saved successfully"});
      commit("setLoadStateOff");
    }
  },
  modules: {
  }
})
